import { Routes } from '@angular/router';
import { ListingComponent } from './containers/listing/listing.component';
import { ListingDetailsComponent } from './containers/listing-details/listing-details.component';
import { ListingDetailsResolver } from './resolvers/listing-details.resolver';
import { ResultsComponent } from './containers/results/results.component';
import { ResultResolver } from './resolvers/result.resolver';

export const listingRoutes: Routes = [
    {
        path: '',
        component: ListingComponent,
        // children: [
        //   {
        //     path: ':listingId',
        //     component: DetailsComponent,
        //     canActivate: [IsLisitngIdValidGuard],
        //     resolve: { taskID: TaskResolver },
        //     children: [
        //       {
        //         path: 'rent',
        //         component: RentComponent,
        //         canActivate: [AuthGuard]
        //       }
        //     ]
        //   }
        // ]
    },
    {
        path: 'details/:listingID',
        component: ListingDetailsComponent,
        resolve: { listingDetails: ListingDetailsResolver },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange'
    },
    {
        path: 'results/:searchedValue',
        component: ResultsComponent,
        resolve: { listing: ResultResolver }
    }
];
